import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const DotnetTextColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.71872 16.2255C2.51908 16.2255 2.34938 16.159 2.20963 16.0259C2.06988 15.8894 2 15.7274 2 15.5398C2 15.3487 2.06988 15.185 2.20963 15.0485C2.34938 14.912 2.51908 14.8438 2.71872 14.8438C2.92169 14.8438 3.09305 14.912 3.2328 15.0485C3.37588 15.185 3.44742 15.3487 3.44742 15.5398C3.44742 15.7274 3.37588 15.8894 3.2328 16.0259C3.09305 16.159 2.92169 16.2255 2.71872 16.2255Z"
      fill="#512BD4"
    />
    <path
      d="M10.6997 16.1129H9.40204L5.98311 10.7191C5.89659 10.5827 5.82506 10.4411 5.76849 10.2944H5.73854C5.76516 10.4513 5.77848 10.7874 5.77848 11.3025V16.1129H4.63052V8.77452H6.01306L9.31715 14.0404C9.4569 14.2587 9.54675 14.4088 9.58669 14.4907H9.60669C9.57337 14.2962 9.55672 13.967 9.55672 13.503V8.77452H10.6997V16.1129Z"
      fill="#512BD4"
    />
    <path
      d="M16.29 16.1129H12.2721V8.77452H16.1303V9.80824H13.46V11.8859H15.9206V12.9145H13.46V15.0843H16.29V16.1129Z"
      fill="#512BD4"
    />
    <path d="M22 9.80824H19.9437V16.1129H18.7558V9.80824H16.7044V8.77452H22V9.80824Z" fill="#512BD4" />
  </Icon>
));

export default DotnetTextColor;
